import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./Pages/auth/Login";
import PrivateRoute from "./components/PrivateRoute";
import Dashboard from "./Pages/management/Dashboard";
import ProjectManagement from "./Pages/management/ProjectManagement/Projects";
import BidManagement from "./Pages/management/BidManagement/Bid";
import Layout from "./components/Layout";

import NotFound from "./Pages/NotFound";
import Users from "./Pages/management/UserManagement/Users";
import Task from "./Pages/management/TaskManagement/Task";
import Cost from "./Pages/management/CostManagement/Cost";
import ScheduleFlowCharts from "./Pages/management/ScheduleFlowCharts/ScheduleFlowCharts";
import ActionSchedule from "./Pages/management/ActionSchedule/ActionSchedule";
import ContractorManagement from "./Pages/management/ContractorManagement/ContractorManagement";
import VendorManagement from "./Pages/management/VendorManagement/VendorManagement";
import ContractManagement from "./Pages/management/ContractManagement/ContractManagement";
import HelpAndSupport from "./Pages/management/HelpAndSupport/HelpAndSupport";
import ProjectsList from "./Pages/management/UserProjectManagement/ProjectsList";
import UsersList from "./Pages/management/UserProjectManagement/UserList";
import ProjectDetails from "./Pages/management/UserProjectManagement/ProjectDetails";
import BidEstimateList from "./Pages/management/UserProjectManagement/BidEstimateList";
import Notes from "./Pages/management/UserProjectManagement/Notes";
import HelpSupport from "./Pages/management/UserProjectManagement/HelpSupport";
import ToDoList from "./Pages/management/UserProjectManagement/ToDoList";
import Forms from "./Pages/management/UserProjectManagement/Forms";
import Selections from "./Pages/management/UserProjectManagement/Selections";
import ScheduleBidEstimate from "./Pages/management/UserProjectManagement/ScheduleBidEstimate";
import VendorUtility from "./Pages/management/UserProjectManagement/VendorUtility";
import PunchList from "./Pages/management/UserProjectManagement/PunchList";
import ActionBidSchedule from "./Pages/management/UserProjectManagement/ActionBidSchedule";
import SubContractorsBidList from "./Pages/management/UserProjectManagement/SubContractorsBidList";
import CostVarienceList from "./Pages/management/UserProjectManagement/CostVarienceList";
import StaticContent from "./Pages/management/StaticContent/StaticContent";
import PublicContent from "./Pages/PublicContent";
import ContactUs from "./Pages/ContactUs";
import ContactUsMessages from "./Pages/management/ContactUsMessages/ContactUsMessages";
import DeleteAccountRequest from "./Pages/DeleteAccountRequest";
import AccountDeletionRequests from "./Pages/management/AccountDeletionRequests/AccountDeletionRequests";

function App() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/about" element={<PublicContent type="about" />} />
        <Route path="/terms" element={<PublicContent type="terms" />} />
        <Route
          path="/privacy-policy"
          element={<PublicContent type="policy" />}
        />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/delete-account-request" element={<DeleteAccountRequest />} />
        <Route path="/" element={<Navigate to="/help-support" replace />} />

        <Route
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/projects" element={<ProjectManagement />} />
          <Route path="/bids" element={<BidManagement />} />
          <Route path="/users" element={<Users />} />
          <Route path="/tasks" element={<Task />} />
          <Route path="/cost" element={<Cost />} />
          <Route
            path="/schedule-flow-charts"
            element={<ScheduleFlowCharts />}
          />
          <Route path="/action-schedule" element={<ActionSchedule />} />
          <Route path="/contractors" element={<ContractorManagement />} />
          <Route path="/vendors" element={<VendorManagement />} />
          <Route path="/form-contract" element={<ContractManagement />} />
          <Route path="/help-support" element={<HelpAndSupport />} />
          <Route path="/static-content" element={<StaticContent />} />
          <Route path="/contact-us-messages" element={<ContactUsMessages />} />
          <Route path="/account-deletion-requests" element={<AccountDeletionRequests />} />
          <Route path="/projects-list/:userId" element={<ProjectsList />} />
          <Route path="/project-details/:projectId" element={<ProjectDetails />} />
          <Route path="/bid-estimate-list/:projectId" element={<BidEstimateList />} />
          <Route path="/notes/:projectId" element={<Notes />} />
          <Route path="/help-and-support/:projectId" element={<HelpSupport />} />
          <Route path="/todo/:projectId" element={<ToDoList />} />
          <Route path="/forms/:projectId" element={<Forms />} />
          <Route path="/selections/:projectId" element={<Selections />} />
          <Route path="/cost-variance/:projectId" element={<CostVarienceList />} />
          <Route path="/bid-tasks/schedule/:taskId" element={<ScheduleBidEstimate />} />
          <Route path="/bid-tasks/vendors-utility/:taskId" element={<VendorUtility />}/>
          <Route path="/bid-tasks/punch-list/:taskId" element={<PunchList />}/>
          <Route path="/bid-tasks/action-schedule/:taskId" element={<ActionBidSchedule />}/>
          <Route path="/bid-tasks/subcontractors/:projectId" element={<SubContractorsBidList />}/>
          <Route path="/users-list" element={<UsersList />} />
          
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
